import { useMemo } from 'react';

export const useDuvalPentagonData = (values, variables, variablesIndex, isPreview) => {
  return useMemo(() => {
    if (!values) return [];

    const hasConfig = variables.some((variable) =>
      values.some((value) => value.variable === variable.id)
    );

    if (!hasConfig) return [];

    return values.reduce((acc, { values: dataValues, name, granularity }) => {
      dataValues.forEach(([time, value, quality]) => {
        const parsedVal = parseFloat(value);
        const cleanedVal = Number.isNaN(parsedVal) ? undefined : parsedVal;

        let axisAlignedValue = cleanedVal;

        if (quality !== 1 && !isPreview) axisAlignedValue = null;

        const index = acc.findIndex((entry) => entry.time === time);
        if (index === -1) {
          const insertIndex = acc.findIndex(
            (_, i) => acc[i].time > time && (acc[i - 1] || {}).time < time
          );
          if (insertIndex === -1) {
            acc.push({
              time,
              [name]: axisAlignedValue,
              granularity,
            });
          } else {
            // eslint-disable-next-line no-param-reassign
            acc = [
              ...acc.slice(0, insertIndex),
              {
                time,
                [name]: axisAlignedValue,
                granularity,
              },
              ...acc.slice(insertIndex),
            ];
          }
        } else {
          acc[index] = {
            ...acc[index],
            [name]: axisAlignedValue,
          };
        }
      });
      return acc;
    }, []);
  }, [values, variables, variablesIndex, isPreview]);
};

export default useDuvalPentagonData;
